import React from "react";
import MainLayout from "../layout/MainLayout";

export default function HomePage() {
    return <MainLayout />;
}
